import Notification from '../../components/Notification/Notification';
import responseCodes from '../../constants/responseCodes';
import { getCurrentStep as fetchCurrentStep } from '../../services/stepsService';
import stepsActionsConstants from '../constants/stepsActionsConstants';

export function getCurrentStep() {
  return (dispatch) => {
    dispatch({ type: stepsActionsConstants.GET_STEP });
    return fetchCurrentStep().then((response) => {
      if (response.data.response_code === responseCodes.OK) {
        dispatch({ type: stepsActionsConstants.GET_STEP_SUCCESS, payload: response.data.payload });
        return response.data.payload;
      }
      Notification.error(response.data.error);
    });
  };
}
